import React from "react";
import { postObjectWithToken} from '../../services/CommonServices'
import { verifyReturnedPayment } from './verifyPayment'
import Spinner from '../Loading/Loading'


class ProcessOrder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            message: "Processing your order"
        }
    }
    componentDidMount() {
        if (window.location.search === "") {
            this.props.history.push({ pathname: '/' })
            return
        }
        verifyReturnedPayment(window.location.search, postObjectWithToken).then((result) => {
            if (result.ok) {
                this.props.history.push({
                    pathname: '/confirmation',
                    state: { order: result.order, receipt: result.receipt }
                })
            } else {
                this.setState({ message: "Your order was not completed successfully.", message2: "Redirecting..." })
            }
        })
    }

    render() {
        return (
            <div style={{ marginTop: 200, marginBottom: 200 }}>
                <h1 style={{ textAlign: "center" }}>{this.state.message}</h1>
                <h2 style={{ textAlign: "center" }}>{this.state.message2}</h2>
                <Spinner />
            </div>
        )
    }
}
export default ProcessOrder;